import { FaInstagram } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import trainerOne from "../assets/images/trainer-1.jpg";
import trainerTwo from "../assets/images/trainer-2.jpg";
import trainerThree from "../assets/images/trainer-3.jpg";
import cristiVideo from "../assets/videos/cristi-video.mp4";

function Trainers() {
    const trainers = [
        {
            id: 1,
            image: trainerOne,
            name: "Andrei Bontas",
            role: "Instructor fitness",
            description:
                "Experienta, disciplina si atentie la detalii pentru antrenamente corecte, progres constant si rezultate construite in timp.",
            extra:
                "Cu o abordare orientata spre executie corecta si evolutie treptata, Andrei te ajuta sa intelegi cum sa lucrezi eficient, in siguranta si cu obiective clare.",
            instagram: "https://instagram.com/andreibontas/",
            instagramLabel: "@andreibontas"
        },
        {
            id: 2,
            video: cristiVideo,
            poster: trainerTwo,
            name: "Cristi Martac",
            role: "Antrenor personal",
            description:
                (
                    <>
                        <p>
                            Mă numesc Cristi Martac. Ca și antrenor personal, înțeleg foarte bine dorința fiecăruia de a avea un corp bine definit și de a te simți excelent în propriul corp, atât din punct de vedere al imaginii personale, cât și din punct de vedere al sănătății.
                        </p>

                        <p>
                            În egală măsură, înțeleg provocările, tentațiile și greutățile pe care le vei întâmpina pe acest drum deloc ușor. Le înțeleg pentru că am fost acolo.
                        </p>
                    </>
                ),
            extra: (
                <>
                    <p>
                        Am lucrat cu persoane care petreceau 8-10 ore la birou și aveau o alimentație haotică, persoane cu o moștenire genetică nefavorabilă, dar și cu persoane gurmande sau dependente de anumite alimente nesănătoase.
                    </p>

                    <p>
                        Am lucrat și cu persoane care până la vârsta de 30 sau 40 de ani au avut un stil de viață sedentar. Ce au toate aceste persoane în comun? Sprijinul și cunoștințele mele acumulate în peste două decenii de experiență practică.
                    </p>

                    <p>
                        Nu am să mai lungesc mult descrierea — te aștept să faci o schimbare în bine în viața ta.
                        <br />
                        <strong>Ne vedem la sală!</strong>
                    </p>
                </>
            ),
            instagram: "https://instagram.com/cristimartac",
            instagramLabel: "@cristimartac"
        },
        {
            id: 3,
            image: trainerThree,
            name: "Echipa Cris Gym",
            role: "Suport si indrumare",
            description:
                "Un mediu in care esti sustinut, ghidat si incurajat sa iti depasesti limitele, indiferent de nivelul de la care pornesti.",
            extra:
                "La Cris Gym gasesti o atmosfera curata, organizata si motivanta, unde fiecare antrenament devine mai usor de urmat si mai aproape de obiectivul tau."
        }
    ];

    return (
        <main className="trainers-page">
            <Helmet>
                <title>Antrenori | Cris Gym Fitness</title>
                <meta
                    name="description"
                    content="Descopera echipa de antrenori de la Cris Gym Fitness si alege mediul potrivit pentru progres, motivatie si rezultate reale."
                />
            </Helmet>

            <section className="trainers-page-hero">
                <div className="trainers-page-container">
                    <p className="trainers-page-label">Antrenori</p>
                    <h1 className="trainers-page-title">
                        O echipa care te ajuta sa evoluezi
                    </h1>
                    <p className="trainers-page-subtitle">
                        Descopera antrenori dedicati, pregatiti sa te ghideze corect si sa
                        transforme fiecare antrenament intr-un pas real spre obiectivul tau.
                    </p>
                </div>
            </section>

            <section className="trainers-sections">
                <div className="trainers-page-container">
                    {trainers.map((trainer, index) => (
                        <article
                            key={trainer.id}
                            className={`trainer-section ${index % 2 !== 0 ? "reverse" : ""}`}
                        >
                            <div className="trainer-section-image-wrapper">
                                {trainer.video ? (
                                    <video
                                        className="trainer-section-image"
                                        src={trainer.video}
                                        poster={trainer.poster}
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                    />
                                ) : (
                                    <img
                                        src={trainer.image}
                                        alt={trainer.name}
                                        className="trainer-section-image"
                                    />
                                )}
                            </div>

                            <div className="trainer-section-content">
                                <span className="trainers-page-role">{trainer.role}</span>
                                <h2 className="trainer-section-name">{trainer.name}</h2>

                                <div className="trainer-section-description">
                                    {trainer.description}
                                </div>

                                <div className="trainer-section-extra">
                                    {trainer.extra}
                                </div>

                                {trainer.instagram && (
                                    <a
                                        href={trainer.instagram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="trainers-page-instagram"
                                    >
                                        <FaInstagram />
                                        <span>{trainer.instagramLabel}</span>
                                    </a>
                                )}

                                <div className="trainers-page-actions">
                                    <Link to="/contact" className="trainers-page-btn primary">
                                        Contact
                                    </Link>
                                    <Link to="/abonamente" className="trainers-page-btn secondary">
                                        Abonamente
                                    </Link>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <section className="trainers-page-cta">
                <div className="trainers-page-container">
                    <h2 className="trainers-page-cta-title">
                        Alege antrenorul potrivit pentru tine
                    </h2>
                    <p className="trainers-page-cta-text">
                        Fa urmatorul pas si incepe sa lucrezi intr-un mediu orientat spre progres real.
                    </p>
                    <div className="trainers-page-cta-buttons">
                        <Link to="/contact" className="trainers-page-btn primary">
                            Programeaza-te
                        </Link>
                        <Link to="/abonamente" className="trainers-page-btn secondary">
                            Vezi abonamentele
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Trainers;